import { PublishedSchema, } from '@dossierhq/core';
import { useCallback } from 'react';
import useSWR from 'swr';
import { CACHE_KEYS } from '../utils/CacheUtils.js';
export function usePublishedSchema(publishedClient) {
    const fetcher = useCallback((_action) => fetchSchema(publishedClient), [publishedClient]);
    const { data, error } = useSWR(CACHE_KEYS.publishedSchema, fetcher);
    // useDebugLogChangedValues('usePublishedSchema changed values', { data, error });
    return { schema: data, schemaError: error };
}
async function fetchSchema(publishedClient) {
    const result = await publishedClient.getSchemaSpecification();
    if (result.isError()) {
        throw result; // throw result, don't convert to Error
    }
    return new PublishedSchema(result.value);
}
//# sourceMappingURL=usePublishedSchema.js.map